import { Global, css } from '@emotion/core';
import { ITheme } from '../../themer';

interface IProps {
	theme: ITheme;
}

export function Base({ theme }: IProps) {
	const styles = css`
		html {
			margin: 0;
			padding: 0;
			box-sizing: border-box;
		}

		*,
		*:before,
		*:after {
			box-sizing: inherit;
		}

		body {
			margin: 0;
			padding: ${theme.layout.page.padding};
			background: ${theme.layout.page.background};

			/* enable smooth scrolling on iOS inside dialogs or other overflown elements */
			-webkit-overflow-scrolling: touch;
		}
	`;

	return <Global styles={styles} />;
}
